import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isDataUri from '../../utils/isDataUri';

import ImageToolbar from './imageToolbar.component';
import { FullSizeImageModal, FULLSIZE_IMAGE_MODAL_DIV_ID } from '../../fullSizeImageModal.component';
import { useModalControl } from '../../../../shared/hooks/useModalControl.hook';
import { editorPropTypes } from '../../propTypes';

const getModalDiv = () => {
  const existingModalDiv = document.getElementById(FULLSIZE_IMAGE_MODAL_DIV_ID);
  if (existingModalDiv) {
    return existingModalDiv;
  }

  const modalDiv = document.createElement('div');
  modalDiv.setAttribute('id', FULLSIZE_IMAGE_MODAL_DIV_ID);

  document.querySelector('body').append(modalDiv);

  return modalDiv;
};

const ImageInline = ({ attributes, node, isSelected, editor }) => {
  const src = node.data.get('src');
  const align = node.data.get('align');
  const portalContainer = getModalDiv();

  const { hideModal, showModal, isModalVisible } = useModalControl();

  const handleSrcChange = useCallback(
    src => editor.setNodeByKey(node.key, { data: { src, align } }),
    [editor, node.key, align]
  );
  const handleAlignChange = useCallback(
    align => editor.setNodeByKey(node.key, { data: { src, align } }),
    [editor, node.key, src]
  );

  const showInput = !isDataUri(src) || !src;

  const image = editor.readOnly
    ? <img className="image__picture image__zoomIn" alt="" src={src} onClick={showModal}/>
    : <img className="image__picture" alt="" src={src} />;

  const fullscreenModal = <FullSizeImageModal
    onClick={hideModal}
    imageSrc={src}
    isVisible={isModalVisible}
  />;

  return (
    <>
      { ReactDOM.createPortal(fullscreenModal, portalContainer) }
      <div
        className={classnames('image__container', {
          'image__container--alignLeft': align === 'left',
          'image__container--alignRight': align === 'right',
        })}
        {...attributes}
      >
        <div className={classnames('image__innerContainer', { 'image__innerContainer--selected': isSelected })}>
          {image}
          {isSelected
            ? (
              <ImageToolbar
                showInput={showInput}
                src={src}
                align={align}
                handleSrcChange={handleSrcChange}
                handleAlignChange={handleAlignChange}
                handleResizeIconClick={showModal}
              />
            )
            : null}
        </div>
      </div>
    </>
  );
};

ImageInline.propTypes = {
  children: PropTypes.node,
  isSelected: PropTypes.bool,
  node: PropTypes.shape({
    key: PropTypes.string,
    data: PropTypes.shape({
      get: PropTypes.func,
    }),
  }),
  editor: editorPropTypes,
  attributes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default ImageInline;
